function buynowcustom(variantId, quantity) {
  // Build the checkout URL
  const checkoutUrl = `/cart/${variantId}:${quantity || 1}`;

  // Redirect to checkout
  window.location.href = checkoutUrl;
}

function addnowcustom(variant, qty) {
  var cartContents = fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items: [
        {
          id: parseInt(variant),
          quantity: qty || 1,
        },
      ],
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.items.length > 0) {
        return document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
      }
      // window.location.href = "/checkout";
    });
}

function updateMmbv2Visibility() {
  const hasCartOpen = document.documentElement.classList.contains("cart-open");
  const mmbv2Elements = document.querySelectorAll(".mmbv2");

  mmbv2Elements.forEach((element) => {
    element.style.display = hasCartOpen ? "none" : "block";
  });
}

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === "attributes" && mutation.attributeName === "class") {
      updateMmbv2Visibility();
    }
  });
});

observer.observe(document.documentElement, {
  attributes: true,
});

document.addEventListener("DOMContentLoaded", updateMmbv2Visibility);

document
  .getElementById("toggleClassBtn")
  .addEventListener("click", function () {
    document.documentElement.classList.toggle("cart-open");
  });
